module.exports = __webpack_public_path__ + "media/images/icons/filled/amazon-circle-dab4bd1701f32cff7710aa805eb3dd4e.svg";